module.exports = __webpack_public_path__ + "static/media/a22_wba.a1b48fa0.png";